import Absence from 'features/absence';
import { useTitle } from '../helpers';

/**
 * @page Absence page
 */
const AbsencePage = () => {
  useTitle('Неявки');

  return (
    <div>
      <Absence />
    </div>
  );
};

export default AbsencePage;
